import { useQuery } from "@apollo/client";
import { Select } from "components/base/Form";
import SearchBar from "components/base/SearchBar";
import PageV2 from "components/shared/PageV2";
import { Link, useSearchParams } from "react-router-dom";
import { FETCH_SALES_PRODUCTS } from "./graphql";
import ProductListView from "./ProductListView";

const Products = () => {
  const [searchParams, setSearchParams] = useSearchParams({
    q: "",
    company: "ALL",
  });
  const params = Object.fromEntries([...searchParams]);
  const { q, company } = params;
  const { loading, error, data } = useQuery(FETCH_SALES_PRODUCTS, {
    variables: { company },
    fetchPolicy: "network-only",
  });

  const header = (
    <div className="flex space-x-4">
      <div>
        <Select
          value={company}
          onChange={(e) =>
            setSearchParams({
              ...searchParams,
              company: e.target.value === "ALL" ? undefined : e.target.value,
            })
          }
        >
          <option value="ALL">All Products</option>
          <option value="AB">AB</option>
          <option value="LTD">LTD</option>
        </Select>
      </div>

      <div className="flex-1">
        <SearchBar
          placeholder="Search by name or number."
          initialQuery={q}
          onChange={(newQ) => setSearchParams({ ...params, q: newQ })}
          autoFocus
        />
      </div>
    </div>
  );

  const footer = (
    <div className="mt-4 opacity-70 text-xs">
      Active products will be shown in this page once it is marked as `Salable`.
    </div>
  );

  return (
    <PageV2
      title="Sales Products"
      toolbar={
        <div>
          <Link to="shopify">Shopify EU Products</Link>
        </div>
      }
    >
      {header}
      <div className="card p-0 flex-1 overflow-auto">
        <ProductListView loading={loading} error={error} data={data} q={q} />
      </div>
      {footer}
    </PageV2>
  );
};

export default Products;
